import { on } from '../helpers';
import View from './view';

const initPage = () => {
    const view = new View();
}

on(window, 'load', initPage);
